import { Button, Col, Form, Modal, Row, } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { editUserName, resetError, resetStatus, updateName } from "../store/userProfileSlice";
import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

const UserNameModal = ({ show, setShow }) => {
    const dispatch = useDispatch();
    const profileDetails = useSelector((state) => state?.userProfile);
    const { errorStatus, data } = useSelector((state) => state?.userProfile);



    useEffect(() => {

        dispatch(updateName(data?.name));
    }, []);

    useEffect(() => {
        if (errorStatus) {
            toast.error("Error while changing the username. Please try again later.")
            dispatch(resetError());
        }
    }, [errorStatus]);

    const handleSubmit = () => {
        if (!profileDetails?.name || profileDetails?.name.trim() === "") {
            toast.error("Please enter your name");
            return;
        }
        const payload = {
            name: profileDetails?.name,
            phone: profileDetails?.phone,
        };

        dispatch(editUserName(payload));
    };

    return (
        <>
            <ToastContainer />

            <Modal show={show} centered size="md" onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Name</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col lg={12}>
                            <Form.Control
                                type="text"
                                name="name"
                                value={profileDetails?.name}
                                placeholder="Enter Your Name"
                                onChange={(e) => {
                                    dispatch(updateName(e.target.value));
                                }}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer style={{ borderTop: '1px solid lightgray' }}>
                    <Row className="py-1">
                        <Col lg={12}>
                            <Button className="mx-2" onClick={handleSubmit}>Save</Button>
                            <Button variant="outline-secondary mx-1" onClick={() => setShow(false)}>Cancel</Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default UserNameModal;
